<template>
  <div v-if="(type && symbol) || type == 'default'">
    <div v-if="['default'].includes(type)">
      <Home_Icon
        v-if="name == 'main'"
        :color="color"
        :style="{
          width: size + 'px',
          height: size + 'px',
          border: outlined_box ? '1px solid #000000' : 'none',
          margin: marginMain,
        }"
      />
      <Activity_Icon
        v-if="name == 'mission'"
        :color="color"
        :style="{
          width: size + 'px',
          height: size + 'px',
          border: outlined_box ? '1px solid #000000' : 'none',
          margin: marginMission,
        }"
        :size="size"
      />
      <Reward_Icon
        v-if="name == 'reward'"
        :color="color"
        :style="{
          width: size + 'px',
          height: size + 'px',
          border: outlined_box ? '1px solid #000000' : 'none',
          margin: marginReward,
        }"
      />
      <Shipment_Icon
        v-if="name == 'transport'"
        :color="color"
        :style="{
          width: size + 'px',
          height: size + 'px',
          border: outlined_box ? '1px solid #000000' : 'none',
          margin: marginTransport,
        }"
      />
      <Account_Icon
        v-if="name == 'account'"
        :color="color"
        :style="{
          width: size + 'px',
          height: size + 'px',
          border: outlined_box ? '1px solid #000000' : 'none',
          margin: marginAccount,
        }"
        :size="size"
      />
      <Chat_Icon
        v-if="name == 'chat'"
        :color="color"
        :style="{
          width: size + 'px',
          height: size + 'px',
          border: outlined_box ? '1px solid #000000' : 'none',
          margin: marginChat,
        }"
        :noti="false"
      />
      <Clipboard_Icon
        v-if="name == 'report'"
        :color="color"
        :style="{
          width: size + 'px',
          height: size + 'px',
          border: outlined_box ? '1px solid #000000' : 'none',
          margin: marginReport,
        }"
      />
      <Campaign_Icon
        v-if="name == 'campaign'"
        :color="color"
        :style="{
          width: size + 'px',
          height: size + 'px',
          border: outlined_box ? '1px solid #000000' : 'none',
          margin: marginCampaign,
        }"
      />
      <Support_Icon
        v-if="name == 'request'"
        :color="color"
        :style="{
          width: size + 'px',
          height: size + 'px',
          border: outlined_box ? '1px solid #000000' : 'none',
          margin: marginRequest,
        }"
      />
      <Warranty_Icon
        v-if="name == 'warranty'"
        :color="color"
        :style="{
          width: size + 'px',
          height: size + 'px',
          border: outlined_box ? '1px solid #000000' : 'none',
          margin: marginWarranty,
        }"
      />
      <Other_Icon
        v-if="name == 'other'"
        :color="color"
        :style="{
          width: size + 'px',
          height: size + 'px',
          border: outlined_box ? '1px solid #000000' : 'none',
          margin: marginOther,
        }"
      />
    </div>
    <div v-if="['icon'].includes(type)">
      <div
        class="d-flex justify-center align-center"
        :style="{
          width: size + 'px',
          height: size + 'px',
          border: outlined_box ? '1px solid #000000' : 'none',
        }"
      >
        <v-icon dark :color="color || ''" :size="size">{{ symbol }}</v-icon>
      </div>
    </div>
    <div v-if="['image'].includes(type)">
      <div v-if="symbol" style="position: relative">
        <v-btn
          v-if="!is_display && !image_file"
          dark
          color="primary"
          small
          icon
          style="position: absolute; top: -24px; z-index: 1"
          :style="{
            left: size - 4 + 'px',
          }"
          @click="handleClearSymbol"
        >
          <v-icon dark> mdi-close </v-icon>
        </v-btn>
        <v-img
          :src="symbol"
          cover
          :style="{
            'max-width': size + 'px',
            height: size + 'px',
            border: outlined_box ? '1px solid #000000' : 'none',
            'background-color': is_image_background_color
              ? '#fafafa'
              : 'transparent',
          }"
        >
        </v-img>
      </div>
    </div>
  </div>
</template>

<script>
import Home_Icon from "./icon/menu-main/home-icon.vue";
import Account_Icon from "./icon/menu-main/account-icon.vue";
import Activity_Icon from "./icon/menu-main/activity-icon.vue";
import Reward_Icon from "./icon/menu-main/reward-icon.vue";
import Shipment_Icon from "./icon/menu-main/shipment-icon.vue";
import Chat_Icon from "./icon/menu-extend/chat-icon.vue";
import Clipboard_Icon from "./icon/menu-extend/clipboard-icon.vue";
import Campaign_Icon from "./icon/menu-extend/campaign-icon.vue";
import Support_Icon from "./icon/menu-extend/support-icon.vue";
import Warranty_Icon from "./icon/menu-extend/warranty-icon.vue";
import Other_Icon from "./icon/menu-extend/other-icon.vue";

export default {
  props: {
    position: { default: "" },
    name: { default: "" },
    type: { default: "" },
    symbol: { default: "" },
    color: { default: "" },
    image_file: { default: null },
    is_image_background_color: { default: false },
    is_display: { default: false },
    outlined_box: { default: true },
    size: { default: 40 },
  },
  emits: ["onClearSymbol"],
  components: {
    Account_Icon,
    Activity_Icon,
    Reward_Icon,
    Home_Icon,
    Shipment_Icon,
    Chat_Icon,
    Clipboard_Icon,
    Campaign_Icon,
    Support_Icon,
    Warranty_Icon,
    Other_Icon,
  },
  data() {
    return {};
  },
  async created() {},
  methods: {
    handleClearSymbol() {
      // this.symbol = null
      this.$emit("onClearSymbol");
    },
  },
  computed: {
    marginMain() {
      let margin = "";
      if (this.position == "shortcut_menu") {
        margin = "";
      } else if (this.position == "bottom_nav_bar") {
        margin = "2px 0px -4px -2px";
      } else if (this.position == "float_panel") {
        margin = "0px 0px -6px -2px";
      } else if (this.position == "page_setting") {
        margin = "";
      }
      return margin;
    },
    marginMission() {
      let margin = "";
      if (this.position == "shortcut_menu") {
        margin = "";
      } else if (this.position == "bottom_nav_bar") {
        margin = "1px 0px -2px -2px";
      } else if (this.position == "float_panel") {
        margin = "";
      } else if (this.position == "page_setting") {
        margin = "0px 0px 0px 4px";
      }
      return margin;
    },
    marginReward() {
      let margin = "";
      if (this.position == "shortcut_menu") {
        margin = "";
      } else if (this.position == "bottom_nav_bar") {
        margin = "2px 0px -4px 0px";
      } else if (this.position == "float_panel") {
        margin = "0px 0px -6px 0px";
      } else if (this.position == "page_setting") {
        margin = "";
      }
      return margin;
    },
    marginTransport() {
      let margin = "";
      if (this.position == "shortcut_menu") {
        margin = "4px 0px -4px 4px";
      } else if (this.position == "bottom_nav_bar") {
        margin = "4px 0px -6px 4px";
      } else if (this.position == "float_panel") {
        margin = "2px 0px -8px 4px";
      } else if (this.position == "page_setting") {
        margin = "0px 0px -8px 0px";
      }
      return margin;
    },
    marginAccount() {
      let margin = "";
      if (this.position == "shortcut_menu") {
        margin = "-2px 0px 0px -2px";
      } else if (this.position == "bottom_nav_bar") {
        margin = "0px 0px -2px 0px";
      } else if (this.position == "float_panel") {
        margin = "";
      } else if (this.position == "page_setting") {
        margin = "";
      }
      return margin;
    },
    marginChat() {
      let margin = "";
      if (this.position == "shortcut_menu") {
        margin = "0px 0px 0px 0px";
      } else if (this.position == "bottom_nav_bar") {
        margin = "2px 0px -4px 0px";
      } else if (this.position == "float_panel") {
        margin = "0px 0px 0px 0px";
      } else if (this.position == "page_setting") {
        margin = "0px 0px 0px 0px";
      }
      return margin;
    },
    marginReport() {
      let margin = "";
      if (this.position == "shortcut_menu") {
        margin = "0px 0px 0px 0px";
      } else if (this.position == "bottom_nav_bar") {
        margin = "2px 0px -4px 0px";
      } else if (this.position == "float_panel") {
        margin = "0px 0px 0px 0px";
      } else if (this.position == "page_setting") {
        margin = "0px 0px 0px 0px";
      }
      return margin;
    },
    marginCampaign() {
      let margin = "";
      if (this.position == "shortcut_menu") {
        margin = "0px 0px 0px 0px";
      } else if (this.position == "bottom_nav_bar") {
        margin = "2px 0px -4px 0px";
      } else if (this.position == "float_panel") {
        margin = "0px 0px 0px 0px";
      } else if (this.position == "page_setting") {
        margin = "0px 0px 0px 0px";
      }
      return margin;
    },
    marginRequest() {
      let margin = "";
      if (this.position == "shortcut_menu") {
        margin = "0px 0px 0px 0px";
      } else if (this.position == "bottom_nav_bar") {
        margin = "2px 0px -4px 0px";
      } else if (this.position == "float_panel") {
        margin = "0px 0px 0px 0px";
      } else if (this.position == "page_setting") {
        margin = "0px 0px 0px 0px";
      }
      return margin;
    },
    marginWarranty() {
      let margin = "";
      if (this.position == "shortcut_menu") {
        margin = "0px 0px 0px 0px";
      } else if (this.position == "bottom_nav_bar") {
        margin = "2px 0px -4px 0px";
      } else if (this.position == "float_panel") {
        margin = "0px 0px 0px 0px";
      } else if (this.position == "page_setting") {
        margin = "0px 0px 0px 0px";
      }
      return margin;
    },
    marginOther() {
      let margin = "";
      if (this.position == "shortcut_menu") {
        margin = "4px 0px -2px -2px";
      } else if (this.position == "bottom_nav_bar") {
        margin = "2px 0px -4px 0px";
      } else if (this.position == "float_panel") {
        margin = "0px 0px 0px 0px";
      } else if (this.position == "page_setting") {
        margin = "0px 0px -8px 0px";
      }
      return margin;
    },
  },
};
</script>

<style>
</style>

<style scoped>
</style>
